/***************************************************************
5/22/2017
Alexander Self
Timesheet Create
- Timesheet form
***************************************************************/
import { TextInput, Select, NumberInput, Textarea, SelectField, SelectBlock,
  SelectCostCenter, SelectEquipment, SelectSubAccount, AutoComplete, FloatingButton,
  DatePicker2, TimePicker2 } from '../../inputs';
import { LOCATIONS, GRADES, SHIFTS, DIFFERENTIAL_SLOT } from '../../../constants';
import { getSelectedValue, generateGUID, onDummyComplete,
  mapEquipmentForAutoComplete, packageDashForm, totalCount, handleWorkPerformedEdit,
  setPaycodeInWorkPerformed, setCCSubInWorkPerformed, handleEquipmentNo } from '../../../utils';
import EditWorkTable from './edit_work_table';

import React, { Component } from 'react';
const $ = window.$;

class TimesheetEditForm extends Component {
  constructor(props) {
    super(props);
    this.packageWorkPerformed = this.packageWorkPerformed.bind(this);
    this.onForceUpdate = this.onForceUpdate.bind(this);
    $(document).ready(() => {
      $('.scrollspy').scrollSpy();
    });
  }
  onForceUpdate() {
    this.forceUpdate();
  }
  packageWorkPerformed(callback) {
    let { hours, trainer, check } = handleWorkPerformedEdit();
    if (!check) return;

    let equipCheck = handleEquipmentNo('edit-ts-equipmentNo', this.props.equipmentNo);
    if (!equipCheck) return;

    callback({
      id: generateGUID(),
      tempGrade: getSelectedValue('edit-ts-tempGrade'),
      costCenterCode: getSelectedValue('edit-ts-costCenterCode'),
      subAccount: getSelectedValue('edit-ts-subAccount'),
      paycode: getSelectedValue('edit-ts-paycode'),
      field: getSelectedValue('edit-tsworkPerformed-field'),
      block: getSelectedValue('edit-tsworkPerformed-block'),
      equipmentNo: document.getElementById('edit-ts-equipmentNo').value,
      equipmentTrailerNo: getSelectedValue('edit-ts-equipmentTrailerNo'),
      differential: getSelectedValue('edit-ts-differential'),
      workPerformed: $.trim(document.getElementById('edit-ts-workPerformed').value),
      detail: document.getElementById('edit-ts-detail').value,
      hours,
      trainer
    });
    document.getElementById("edit-second-ts-form").reset();
    return;
  }
  render() {
    return (
        <div>
          <div className="col s12 m9 l10 xl10">
            <div id="edit-ts-mtimesheet" className="section scrollspy">
              <form onSubmit={(e) => e.preventDefault()} id="edit-ts-form" className="form-rerender">
                <div className="row">
                  <div className="col s12 m12 l12">
                    <Textarea id={'edit-ts-reasonForEdit'} label={'Reason for Edit'} />
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m12 l4">
                    <DatePicker2 id={'edit-ts-date'} label={'Date'} min={this.props.payPeriodStartDate} max={this.props.payPeriodEndDate} />
                  </div>
                  <div className="col s12 m12 l4">
                    <Select id={'edit-ts-location'} opts={LOCATIONS} label={'Location'}
                      onChange={(e) => {
                        this.props.fetchFieldsByLoc(e.target.value);
                        this.props.selectCostCenterByLocation(e.target.value);
                        this.onForceUpdate();
                      }}
                    />
                  </div>
                  
                  <div className="col s12 m12 l4">
                    <TextInput id={'edit-ts-gang'} label={'Team No.'} />
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m6 l3">
                    <TimePicker2 id={'edit-ts-startTime'} label={'Start Time'} />
                  </div>
                  <div className="col s12 m6 l3">
                    <TimePicker2 id={'edit-ts-endTime'} label={'End Time'} />
                  </div>
                  <div className="col s12 m6 l3">
                    <Select id={'edit-ts-shift'} opts={SHIFTS} label={'Shift'} />
                  </div>
                  <div className="col s12 m6 l3">
                    <NumberInput id={'edit-ts-round'} label={'Round'} min={1} max={6} step={1} defaultValue={1} />
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m12 l12 xl12">
                    <input type="checkbox" id="edit-ts-dustPay" />
                    <label htmlFor="edit-ts-dustPay">Dust Pay</label>
                  </div>
                </div>
              </form>
              <hr />
            </div>
            <div id="edit-ts-stimesheet" className="section scrollspy">
              <center>
                <p className="flow-text">Individual Work Form</p>
              </center>
              <hr />
              <form onSubmit={(e) => e.preventDefault()} id="edit-second-ts-form" >
                <div className="row">
                  <div className="col s12 m12 l4">
                    <Select id={'edit-ts-tempGrade'} opts={GRADES} label={'Temp Grade'} />
                  </div>
                  <div className="col s12 m12 l4">
                    <SelectCostCenter id={'edit-ts-costCenterCode'} opts={this.props.costCenters} label={'Cost Center'} onChange={(e) => { this.props.fetchSubAccounts(e.target.value); this.onForceUpdate(); }} />
                  </div>
                  <div className="col s12 m12 l4">
                    <SelectSubAccount id={'edit-ts-subAccount'} opts={this.props.subAccounts} label={'Sub Account'} onChange={(e) => setCCSubInWorkPerformed('edit-ts-workPerformed', 'edit-ts-costCenterCode', e.target.id)} />
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m12 l3">
                    <Select id={'edit-ts-paycode'}
                      opts={this.props.paycodes.map((p) => { return { val: p.code, label: p.label } })}
                      label={'Special Pay Code'}
                      onChange={(e) => setPaycodeInWorkPerformed('edit-ts-workPerformed', e.target.id)}
                    />
                  </div>
                  <div className="col s12 m12 l3">
                    <SelectField id={'edit-tsworkPerformed-field'} label={'Field No.'} opts={this.props.fields}
                      onChange={(e) => { this.props.fetchBlocksByField(e.target.value); this.onForceUpdate(); }}
                    />
                  </div>
                  <div className="col s12 m12 l3">
                    <SelectBlock id={'edit-tsworkPerformed-block'} label={'Block No.'} opts={this.props.blocks} />
                  </div>
                  <div className="col s12 m12 l3 xl3">
                    <Select id={'edit-ts-detail'} opts={this.props.details.map((d) => { return { val: d.detail, label: `${d.detail} - ${d.description}` } })} label={'Detail'} />
                    {/* <TextInput id={'edit-ts-detail'} label={'Detail'} placeholder={'Ex: 8954'} /> */}
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m12 l3">
                    <AutoComplete id={'edit-ts-equipmentNo'} label={'Equipment No.'}
                      data={mapEquipmentForAutoComplete(this.props.equipmentNo)} onComplete={onDummyComplete}  />
                  </div>
                  <div className="col s12 m12 l3">
                    <SelectEquipment id={'edit-ts-equipmentTrailerNo'} opts={this.props.equipmentTrailerNo} label={'Equipment Trailer No.'} />
                  </div>
                  <div className="col s12 m12 l3 xl3">
                    <Select id={'edit-ts-differential'} label={'Differential'} opts={DIFFERENTIAL_SLOT} />
                  </div>
                  <div className="col s12 m12 l3 xl3">
                    <p className="trainer"><input type="checkbox" id="edit-ts-trainer" />
                    <label htmlFor="edit-ts-trainer">Trainer</label></p>
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m12 l8">
                    <TextInput id={'edit-ts-workPerformed'} label={'Work Performed'} />
                  </div>
                  <div className="col s12 m12 l4">
                    <NumberInput id={'edit-ts-hours'} min={"0"} max={"16"} label={'Hours'} step={"0.1"} />
                  </div>
                  <div className="col s12 m12 l2">
                    <button onClick={() => this.packageWorkPerformed(this.props.addWork)} className="btn waves-effect waves-light">Add Work</button>
                  </div>
                  <div className="col s12 m12 l2">
                    <button id={'ind-work-edit-ts-btn'} onClick={() => this.packageWorkPerformed(this.props.editWorkRecord)} className="btn waves-effect waves-light blue">Edit Work</button>
                  </div>
                </div>
                <div className="row">
                  <div className="col s12 m12 l12">
                    <EditWorkTable work={this.props.work} removeWork={this.props.removeWork} editWork={this.props.editWork} />
                  </div>
                </div>
              </form>
            </div>
            <div id="edit-ts-htimesheet" className="section scrollspy">
              <center>
                <p className="flow-text">Harvest</p>
              </center>
              <hr />
              <form onSubmit={(e) => e.preventDefault()} id="edit-harvest-ts-form">
                <div className="row">
                  <div className="col s2 m2 l2 xl2">
                    <NumberInput id={`edit-ts-hours`} min={"0"} max={"8"} step={"0.05"} label={'Hours'} />
                  </div>
                  <div className="col s2 m2 l2 xl2">
                    <NumberInput id={`edit-ts-trees`} min={"0"} max={"75"} step={"0.05"} label={'Trees'} />
                  </div>
                  <div className="col s2 m2 l2 xl2">
                    <NumberInput id={`edit-ts-bags`} min={"0"} max={"25"} step={"0.05"} label={'Bags'} />
                  </div>
                  <div className="col s2 m2 l2 xl2">
                    <SelectField id={`edit-ts-field`} label={'Field'} opts={this.props.fields}
                      onChange={(event) => this.props.fetchBlocksByField(event.target.value,`edit-ts-field`)} />
                  </div>
                  <div className="col s2 m2 l2 xl2">
                    <SelectBlock id={`edit-ts-block`} label={'Block'} opts={this.props.blocks} />
                  </div>
                  <div className="col s2 m2 l2 xl2 mt-2">
                    <FloatingButton color={'green'} icon={'add'} onclick={() => {this.props.addHarvest(packageDashForm('edit-harvest-ts-form')); document.getElementById('edit-harvest-ts-form').reset(); }} />
                  </div>
                  <div className="col s12 m12 l2">
                    <FloatingButton id={'edit-harvest-btn'} color={'blue'} icon={'mode_edit'} onclick={() => { this.props.editHarvest('edit-harvest-ts-form', this.props.harvestToEdit); document.getElementById('edit-harvest-ts-form').reset(); }} />
                  </div>
                </div>
                <div>
                {
                  this.props.harvestTimesheet.length > 0 ?
                    <table className="responsive-table centered highlight bordered">
                      <thead>
                        <tr>
                          <th>Hours</th>
                          <th>Trees</th>
                          <th>Bags</th>
                          <th>Field</th>
                          <th>Block</th>
                          <th>Edit</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.props.harvestTimesheet.map((h) => (
                            <tr key={h.id}>
                              <td>{h.hours}</td>
                              <td>{h.trees}</td>
                              <td>{h.bags}</td>
                              <td>{h.field}</td>
                              <td>{h.block}</td>
                              <td><FloatingButton color={'blue'} icon={'mode_edit'} onclick={() => this.props.selectHarvestToEdit('edit-harvest-ts-form', h)} /></td>
                              <td><FloatingButton color={'red'} icon={'clear'} onclick={() => this.props.removeHarvest(h.id)} /></td>
                            </tr>
                          ))
                        }
                      </tbody>
                      <tfoot>
                        <tr>
                          <td><center><b>{ totalCount(this.props.harvestTimesheet, 'hours')}</b></center></td>
                          <td><center><b>{ totalCount(this.props.harvestTimesheet, 'trees')}</b></center></td>
                          <td><center><b>{ totalCount(this.props.harvestTimesheet, 'bags')}</b></center></td>
                        </tr>
                      </tfoot>
                    </table>
                  : ''
                }
                </div>
              </form>
            </div>
          </div>
          <div className="col hide-on-small-only m3 l2 xl2">
            <ul id="edit-table-of-contents" className="section table-of-contents">
              <li><a href="#edit-ts-mtimesheet">Main</a></li>
              <li><a href="#edit-ts-stimesheet">Individual Work</a></li>
              <li><a href="#edit-ts-htimesheet">Harvest</a></li>
            </ul>
          </div>


        </div>
    );
  }
};

export default TimesheetEditForm;



















/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/edit/timesheet_edit_form.js